import { Table } from "flowbite-react";
import { formatToReal } from "../../../utils/utils";
import TitleStripe from "../TitleStripe";

const PrecificadorTabela = ({ data }) => {
  return (
    <div>
      {data?.map((item, idx) => (
        <div key={idx}>
          <TitleStripe className="bg-green-200">{item?.modelo}</TitleStripe>
          <div className="flex gap-20 items-start mt-4 mb-5">
            <div className="flex flex-col gap-3 mb-4">
              <div>
                <span className="font-semibold inline-block mr-2">
                  Ano Modelo:
                </span>
                {item?.ano_modelo || "Não informado"}
              </div>
              <div>
                <span className="font-semibold inline-block mr-2">
                  Código Fipe:
                </span>
                {item?.codigo_fipe || "Não informado"}
              </div>
              <div>
                <span className="font-semibold inline-block mr-2">
                  Montadora:
                </span>
                {item?.montadora || "Não informado"}
              </div>
              <div>
                <span className="font-semibold inline-block mr-2">Modelo:</span>
                {item?.modelo || "Não informado"}
              </div>
              <div>
                <span className="font-semibold inline-block mr-2">
                  Vigência:
                </span>
                {item?.vigencia || "Não informado"}
              </div>
              <div>
                <span className="font-semibold inline-block mr-2">
                  Preço Fipe:
                </span>
                {formatToReal(item?.preco_fipe) || "Não informado"}
              </div>
            </div>
            <img className="max-w-sm" src={item?.grafico_historico} />
          </div>
          {item?.historico?.length > 0 && (
            <div className="rounded-md overflow-hidden border border-gray-100 mt-3 mb-10">
              <Table striped className="w-full">
                <Table.Head>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Mês Ref.
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Cód. Fipe
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Ano
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Marca
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Modelo
                  </td>
                  <td className="bg-primary py-1 px-1 text-center font-semibold text-2xs text-white">
                    Valor
                  </td>
                </Table.Head>
                <Table.Body>
                  {item?.historico?.map((info, index) => (
                    <tr
                      key={index}
                      className={`${
                        index % 2 === 0 ? "bg-white" : "bg-gray-100"
                      }`}
                    >
                      <td className="p-1 text-center">{info?.mesreferencia}</td>
                      <td className="p-1 text-center">{info?.codigofipe}</td>
                      <td className="p-1 text-center">{info?.ano}</td>
                      <td className="p-1 text-center">{info?.marca}</td>
                      <td className="p-1 text-center">{info?.modelo}</td>
                      <td className="p-1 text-center">{info?.valor}</td>
                    </tr>
                  ))}
                </Table.Body>
              </Table>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PrecificadorTabela;
